import React from "react";
import { useAuth } from "../auth/contexts/AuthProvider";
import { useSyncUserProfile } from "./useSyncUserProfile";

export function AuthProfileSync({ children }: { children: React.ReactNode }) {
  const { userInfo } = useAuth();
  useSyncUserProfile(!!userInfo);
  return <>{children}</>;
}
